/* =====================================================
   PRODUCT CARD IMAGE SLIDER — alexelcrafts-2026 (new)
   ===================================================== */
(function () {
  'use strict';

  var AUTO_DELAY = 1800;
  var TOUCH_THRESHOLD = 40;

  function initSliders() {
    document.querySelectorAll('[data-ac-slider]').forEach(function(el) {
      if (!el.dataset.acSliderInit) initOneSlider(el);
    });
  }

  function initOneSlider(sliderEl) {
    var slides = sliderEl.querySelectorAll('[data-ac-slide]');
    var dots   = sliderEl.querySelectorAll('[data-ac-dot]');
    var prevBtn = sliderEl.querySelector('[data-ac-prev]');
    var nextBtn = sliderEl.querySelector('[data-ac-next]');
    var total   = slides.length;

    if (total <= 1) return;
    sliderEl.dataset.acSliderInit = '1';

    var current = 0;
    var autoTimer = null;
    var touchStartX = null;
    var touchStartY = null;

    function goTo(index) {
      index = ((index % total) + total) % total;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(next, AUTO_DELAY);
    }

    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    // Hover: auto-advance, leave: reset to first
    sliderEl.addEventListener('mouseenter', startAuto);
    sliderEl.addEventListener('mouseleave', function() {
      stopAuto();
      goTo(0);
    });

    // Prev/next click zones
    if (prevBtn) prevBtn.addEventListener('click', function(e) {
      e.preventDefault(); stopAuto(); prev(); startAuto();
    });
    if (nextBtn) nextBtn.addEventListener('click', function(e) {
      e.preventDefault(); stopAuto(); next(); startAuto();
    });

    // Dot clicks
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        stopAuto();
        goTo(parseInt(dot.dataset.acDot, 10));
      });
    });

    // Touch / swipe
    sliderEl.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, {passive: true});

    sliderEl.addEventListener('touchend', function(e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > TOUCH_THRESHOLD) {
        dx < 0 ? next() : prev();
      }
      touchStartX = null; touchStartY = null;
    }, {passive: true});
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  // Re-init after Shopify section loads (theme editor)
  document.addEventListener('shopify:section:load', initSliders);

  // MutationObserver for filter apps / infinite scroll
  document.addEventListener('DOMContentLoaded', function() {
    var grid = document.querySelector('.productListing, .collection, [data-product-grid]');
    if (!grid) return;
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          var newSliders = node.querySelectorAll ? node.querySelectorAll('[data-ac-slider]') : [];
          newSliders.forEach(initOneSlider);
          if (node.matches && node.matches('[data-ac-slider]')) initOneSlider(node);
        });
      });
    });
    observer.observe(grid, {childList: true, subtree: true});
  });
})();

/* =====================================================
   MEGA MENU PRODUCT PRELOAD
   ===================================================== */
(function () {
  'use strict';

  var HALO_WAIT_LIMIT = 20;
  var HALO_WAIT_DELAY = 150;

  function promoteImage(img) {
    var srcset = img.getAttribute('data-srcset');
    var src = img.getAttribute('data-src');
    var sizes = img.getAttribute('data-sizes');

    if (srcset && !img.getAttribute('srcset')) img.setAttribute('srcset', srcset);
    if (src && !img.getAttribute('src')) img.setAttribute('src', src);
    if (sizes && !img.getAttribute('sizes')) img.setAttribute('sizes', sizes);

    img.setAttribute('loading', 'eager');
    img.setAttribute('fetchpriority', 'high');
    img.classList.remove('lazyload', 'lazyloading');
    img.classList.add('lazyloaded');
  }

  function preloadMenuImages(menu) {
    if (!menu) return;
    menu.querySelectorAll('img.lazyload, img.lazyloading, img[data-src], img[data-srcset]').forEach(promoteImage);
    menu.querySelectorAll('.data-lazy-loading').forEach(function(loader) {
      loader.style.display = 'none';
    });
  }

  function getMenuProductUrl(block) {
    var root = (window.routes && window.routes.root) ? window.routes.root.replace(/\/$/, '') : '';
    var productHandle = block.getAttribute('data-product');
    var collectionHandle = block.getAttribute('data-collection');

    if (block.classList.contains('megamenu_1') && productHandle) {
      return root + '/products/' + productHandle;
    }

    if (block.classList.contains('megamenu_5') && collectionHandle) {
      return root + '/collections/' + collectionHandle;
    }

    return null;
  }

  function preloadProductBlock(block) {
    if (!block || block.classList.contains('ajax-loaded') || block.dataset.acMegaProductQueued) return;

    var url = getMenuProductUrl(block);
    if (!url || !window.halo || typeof window.halo.renderMegaMenuProductBlock !== 'function' || !window.jQuery) return;

    block.dataset.acMegaProductQueued = '1';
    window.halo.renderMegaMenuProductBlock(window.jQuery(block), url);
  }

  function preloadAllProductBlocks() {
    document.querySelectorAll('.menu-dropdown__block--content .products-carousel').forEach(preloadProductBlock);
  }

  function preloadMenuProducts(menu) {
    if (!menu) return;
    menu.querySelectorAll('.menu-dropdown__block--content .products-carousel').forEach(preloadProductBlock);
  }

  function initHoverImagePreload() {
    document.querySelectorAll('.menu-lv-item.has-megamenu').forEach(function(item) {
      if (item.dataset.acMenuPreloadInit) return;
      item.dataset.acMenuPreloadInit = '1';

      var menu = item.querySelector('.menu-dropdown');
      item.addEventListener('mouseenter', function() {
        preloadMenuImages(menu);
        preloadMenuProducts(menu);
      });
      item.addEventListener('focusin', function() {
        preloadMenuImages(menu);
        preloadMenuProducts(menu);
      });
      item.addEventListener('touchstart', function() {
        preloadMenuImages(menu);
        preloadMenuProducts(menu);
      }, { passive: true });
    });
  }

  function whenHaloReady(callback, attempt) {
    attempt = attempt || 0;

    if (window.halo && typeof window.halo.renderMegaMenuProductBlock === 'function' && window.jQuery) {
      callback();
      return;
    }

    if (attempt >= HALO_WAIT_LIMIT) return;
    window.setTimeout(function() {
      whenHaloReady(callback, attempt + 1);
    }, HALO_WAIT_DELAY);
  }

  function scheduleProductPreload() {
    whenHaloReady(function() {
      var run = function() {
        preloadAllProductBlocks();
        window.setTimeout(preloadAllProductBlocks, 1200);
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1800 });
      } else {
        window.setTimeout(run, 600);
      }
    });
  }

  function initMegaMenuPreload() {
    initHoverImagePreload();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuPreload);
  } else {
    initMegaMenuPreload();
  }

  document.addEventListener('shopify:section:load', initMegaMenuPreload);
})();
